import { defineMessages } from 'react-intl'

export const caseCardMessages = defineMessages({
  unassigned: {
    defaultMessage: 'Unassigned',
    description: 'case card — nobody is assigned to this case',
  },
  updatedRelative: {
    defaultMessage: 'Updated {time}',
    description: 'case card — relative time of the last update',
  },
})
